<template>
  <div>
    <label :for=label>{{ labelFormatted }}</label>
    <input type="text"
           :id="label"
           :value="modelValue"
           @input="event => $emit('update:modelValue', event.target.value)"
           :required="required"/>
    <p v-if="errorMsg">{{ errorMsg }}</p>
  </div>
</template>

<script>
import {computed, defineComponent} from "vue";

export default defineComponent({
  name: 'textInputField',
  emits: ['update:modelValue'],
  props: {
    label: {
      type: String,
      required: false,
      default: ""
    },
    id: {
      type: String,
      required: true,
      default: ""
    },
    modelValue: {
      type: String,
      required: false,
      default: ""
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    errorMsg: {
      type: String,
      required: false,
      default: ""
    }
  },
  setup(props) {
    const labelFormatted = computed(() => {
      return props.label;
    })
    return {labelFormatted}
  }
})
</script>

<style scoped lang="scss">
@import '@/styles/defaults.scss';

div {
  display: flex;
  flex-direction: column;
}

label {
  margin-bottom: 5px;
}

p {
  color: $error-color;
  font-size: 14px;
  font-style: italic;
}
</style>